module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "back-button right mb11",
    attrs: {
      "tag": "a",
      "to": "/portfolio"
    }
  }, [_vm._v("Back to portfolio")]), _vm._v(" "), _c('h2', {
    staticClass: "main-headline"
  }, [_vm._v("CLIENT LIST")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "select-title"
  }, [_vm._v("Select a State:")]), _vm._v(" "), _c('div', {
    staticClass: "select-wrapper"
  }, [_c('div', {
    staticClass: "select-inner"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedState),
      expression: "selectedState"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedState = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statesList), function(sCode) {
    return _c('option', {
      domProps: {
        "value": sCode
      }
    }, [_vm._v(_vm._s(sCode))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "clients-list-container"
  }, [(_vm.selectedListCount >= _vm.maxNumForSingleColumn) ? [_c('div', {
    staticClass: "clients-list-left"
  }, [_vm._l((_vm.selectedList), function(client, idx) {
    return [(idx < Math.ceil(_vm.selectedListCount / 2)) ? _c('span', [_vm._v("\n                        " + _vm._s(client) + "\n                    ")]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clients-list-right"
  }, [_vm._l((_vm.selectedList), function(client, idx) {
    return [(idx >= Math.ceil(_vm.selectedListCount / 2)) ? _c('span', [_vm._v("\n                        " + _vm._s(client) + "\n                    ")]) : _vm._e()]
  })], 2)] : [_c('div', {
    staticClass: "clients-list"
  }, [_vm._l((_vm.selectedList), function(client, idx) {
    return [_c('span', [_vm._v(_vm._s(client))])]
  })], 2)]], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "subheadline"
  }, [_vm._v("In our 30+ years, our projects have been featured across the U.S., Canada and\n        "), _c('br'), _vm._v(" Mexico, everywhere from stadiums and venues to schools, churches,\n        "), _c('br'), _vm._v(" parks, military venues and other community gathering spaces. Listed\n        "), _c('br'), _vm._v(" below is our complete client list organized by state.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1381280c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/our-work/Clients.vue
// module id = cSbH
// module chunks = 1